import React from 'react';
import useAuth from '../hooks/useAuth';

const ProtectedPage = () => {
  useAuth();

  return <div>This is a protected page.</div>;
};

export default ProtectedPage;